import { render } from "./empaqueplatillos.vue?vue&type=template&id=b64d0a92&scoped=true"
import script from "./empaqueplatillos.vue?vue&type=script&lang=js"
export * from "./empaqueplatillos.vue?vue&type=script&lang=js"

import "./empaqueplatillos.vue?vue&type=style&index=0&id=b64d0a92&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b64d0a92"]])

export default __exports__